<template>
  <Socials v-if="currentUser" :currentUser="currentUser" />
</template>

<script>
import { mapGetters } from 'vuex'
import Socials from '@/components/settings/Socials'

export default {
  name: 'SocialsView',

  computed: {
    ...mapGetters(['currentUser'])
  },

  components: {
    Socials
  }
}
</script>
